class ArticleLinks extends HTMLElement {
  constructor() {
    super();

    this.articleContent = document.querySelector(".js-article-content");
    this.list = this.querySelector("ul");
    this.animateContent = this.dataset.animate === "true";
    this.isDesktop = window.matchMedia("(min-width: 990px)").matches;

    if (this.articleContent) {
      this.generateLinks();
    }
  }

  generateLinks() {
    const headings = this.articleContent.querySelectorAll("h2");

    if (headings.length) {
      const scrollIndicator = this.querySelector(".js-scroll-indicator");

      headings.forEach((heading, index) => {
        heading.classList.add("js-anchor-link-" + index);

        let li = document.createElement("li");

        if (this.animateContent) {
          li.classList.add("scroll-trigger", "animate--slide-in");
          li.style.setProperty("--animation-order", index);
        }

        li.innerHTML = `<strong>${String(index + 1).padStart(
          2,
          "0"
        )}.</strong><span>${heading.innerText}</span>`;

        li.setAttribute("data-index", index);

        this.list.appendChild(li);

        li.addEventListener("click", () => {
          const headingIndex = li.getAttribute("data-index");
          const headingElem = document.querySelector(
            ".js-anchor-link-" + headingIndex
          );

          if (headingElem) {
            headingElem.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "nearest",
            });
          }
        });
      });

      if (!this.animateContent && !this.isDesktop) return;

      // IntersectionObserver to update the scroll indicator
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const index = Array.from(headings).indexOf(entry.target);
              scrollIndicator.style.transform = `translateY(${index * 30}px)`;
            }
          });
        },
        { root: null, rootMargin: "0px 0px -50% 0px", threshold: 0 }
      );

      headings.forEach((heading) => observer.observe(heading));
    } else {
      this.classList.add("hidden");
    }
  }}

customElements.define("article-links", ArticleLinks);
